/**
* @ngdoc component
* @name common.address.component:itxAddressLastname
* @description
* Component description
*/
(function() {
    'use strict';

    var itxAddressLastname = {
        bindings: {
            model:'=',
            form:'=',
            class:'<',
            secondLastName:'<',
            completeInfo: '=',
            isChina: '<',
            checkRequired:'<'
        },
        controller:   itxAddressLastnameCtrl,
        templateUrl: 'address-lastname.component.html'
    };

    itxAddressLastnameCtrl.$inject = [
        'CountryService',
        'DUTTI_CONS',
        'ItxTranslateSvc',
        'crmService',
        'CmsConfigSvc',
        'MdFeelMyAccountService'
    ];

    function itxAddressLastnameCtrl (
        CountryService, 
        DUTTI_CONS,
        ItxTranslateSvc,
        crmService,
        CmsConfigSvc,
        MdFeelMyAccountService
    ) {
        var _this = this;
        _this.systemPointsEnabled = false;
        _this.is200enabled = false;

        _this.$onInit = function () {
            _this.is360 = crmService.is360();

            _this.text = {};
            _this.text.lastnamePlaceholder = (_this.secondLastName)? 
                ItxTranslateSvc.translateCms('legacy.ItxMyAccountOrderReturnPaymentView.label.lastName') : 
                ItxTranslateSvc.translateCms('legacy.CommonErrorFields.input.lastName');
            _this.isRequired = !CountryService.isWWCountry();

            // Comprobacion del estado del sistema de puntos
            CmsConfigSvc.getProperty('feel_points_program_enabled').then(function (systemPointsEnabled) {
                if (systemPointsEnabled) {
                    _this.systemPointsEnabled = true;
                }
            });

            MdFeelMyAccountService.check200PointsEnabled().then(function (isEnabled) {
                _this.is200enabled = true;
            });

        };

        _this.$onChanges = function (changeObj) {
            if(typeof changeObj.checkRequired != undefined){
                _this.isRequired = changeObj.checkRequired.currentValue;
            } 
        };
    }

    angular.module('itxApp.common')
    .component('itxAddressLastname',itxAddressLastname);
})();